import { render, staticRenderFns } from "./addPerson.vue?vue&type=template&id=1d4a8aad&"
import script from "./addPerson.vue?vue&type=script&lang=js&"
export * from "./addPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports